module.exports = __webpack_public_path__ + "static/media/log-text.27122445.png";